import axios, { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import environment from "@/settings/environment";

export interface Fetch {
  hash: string;
  company?: string;
  callback: (success: boolean, plate?: string) => void;
}

export interface CheckLicensePlateHashAction {
  type: string;
  payload: Fetch;
}

export default function* checkLicensePlateHash({
  payload,
}: CheckLicensePlateHashAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const url = `${environment.api.baseUriAuth}/webapi/v1/vehicle-debts/check-license-plate-hash`;

    const data: { hash: string; company?: string } = {
      hash: payload.hash,
    };

    if (payload.company) {
      data.company = payload.company;
    }

    const response = yield call(axios.post, url, data, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.api.apiKeyAuth,
      },
    });

    const responseData = response?.data;

    if (
      responseData?.status?.codigoRetorno === 0 &&
      responseData?.data?.licensePlate
    ) {
      yield call(payload.callback, true, responseData.data.licensePlate);
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
